module.exports = __webpack_public_path__ + "static/media/Skyzone.9f710733.pdf";